import { createSlice } from "@reduxjs/toolkit";
import { AddReturn, GetReturns, UpdateReturn, GetReturnItems } from "services/return/return.service";
import { toast } from 'react-toastify';


export const returnAddSlice = createSlice({
  name: "returnAdd",
  initialState: {
    returnAdd: {},
    returnAddLoading: false,
    returnAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddReturn.pending, (state) => {
      // toast.loading('We are adding the return 🤯')
      state.returnAddLoading = true
    });

    builder.addCase(AddReturn.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New return added successfully 👌');

      state.returnAdd = action.payload
      state.returnAddLoading = false
      state.returnAddError = null
    });

    builder.addCase(AddReturn.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the return 😣")

      state.returnAddLoading = false
      state.returnAddError = action.error?.message
      toast.error(action.error?.message)
    });
  },
});

export const returnUpdateSlice = createSlice({
  name: "returnUpdate",
  initialState: {
    returnUpdate: {},
    returnUpdateLoading: false,
    returnUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateReturn.pending, (state) => {
      // toast.loading('We are updating the requisition 🤯')
      state.returnUpdateLoading = true
    });

    builder.addCase(UpdateReturn.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Requisition update successfully 👌');

      state.returnUpdate = action.payload
      state.returnUpdateLoading = false
      state.returnUpdateError = null
    });

    builder.addCase(UpdateReturn.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the requisition 😣")

      state.returnUpdateLoading = false
      state.returnUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});


export const returnListSlice = createSlice({
  name: "returnList",
  initialState: {
    returnList: [],
    returnListLoading: false,
    returnListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetReturns.pending, (state) => {
      state.returnListLoading = true
    });

    builder.addCase(GetReturns.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.returnList = action.payload
      state.returnListLoading = false
      state.returnListError = null
    });

    builder.addCase(GetReturns.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.returnListLoading = false
      state.returnListError = action.error?.message
    });
  },
});

export const returnItemsSlice = createSlice({
  name: "returnItems",
  initialState: {
    returnItems: [],
    returnItemsLoading: false,
    returnItemsError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetReturnItems.pending, (state) => {
      state.returnItemsLoading = true
    });

    builder.addCase(GetReturnItems.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved for sale detail👌');

      state.returnItems = action.payload
      state.returnItemsLoading = false
      state.returnItemsError = null
    });

    builder.addCase(GetReturnItems.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected for return items 🤯 😣')

      state.returnItemsLoading = false
      state.returnItemsError = action.error?.message
    });
  },
});